import React from "react";
import {Col, Row, Typography} from "antd";

export default ({title, description}) => <Col span={24} style={{paddingBottom: 6, paddingTop: 6}}>
    <Row gutter={10}>
        <Col span={9}><Typography.Text type="secondary">{title}</Typography.Text></Col>
        <Col span={15}>{description}</Col>
    </Row>
</Col>
